export default {
    methods: {
        t(string, params) {
            return this.$root.t(string, params);
        },
    },
};
